import PropTypes from "prop-types";
import React from "react";
import { connect } from "react-redux";

import { resourceTypes } from "../../policies/actions";
import { ProductShape,ResourceTypeShape } from "../../policies/proptypes";
import resourceTypeSelectors from "../../policies/selectors/resource-types";
import ScopeTypeItem from "../components/ScopeTypeItem";

const ScopeTypesByProduct = ({
  currentResourceType,
  product,
  resourceTypes,
  setCurrentType
}) => (
  <li className="p-list__item">
    <div style={{ padding: ".3125rem .5rem" }}>{product.name}</div>
    <ul className="p-list">
      {resourceTypes.map(resourceType => (
        <ScopeTypeItem
          key={resourceType.$uri}
          resourceType={resourceType}
          setCurrent={setCurrentType}
          selected={
            currentResourceType
              ? currentResourceType.$uri === resourceType.$uri
              : false
          }
        />
      ))}
    </ul>
  </li>
);

ScopeTypesByProduct.propTypes = {
  currentResourceType: ResourceTypeShape,
  product: ProductShape.isRequired,
  resourceTypes: PropTypes.arrayOf(ResourceTypeShape).isRequired,
  setCurrentType: PropTypes.func.isRequired
};

ScopeTypesByProduct.defaultProps = {
  currentResourceType: undefined
};

const mapStateToProps = (state, props) => ({
  currentResourceType: resourceTypeSelectors.getCurrent(state),
  resourceTypes: resourceTypeSelectors.getByProduct(state, props.product)
});

const mapDispatchToProps = {
  setCurrentType: resourceTypes.setCurrent
};

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(ScopeTypesByProduct);
